import {TrackEntity} from '@spout/any-shared/models';
import {removeProperties} from '../remove-properties';

export function removeTrackPropertiesBeforeSavingToFirestore(trackConfig: TrackEntity): TrackEntity {
  return removeProperties(trackConfig, ['isCurrentTrack']);
}
